import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Link } from 'react-router-dom';
import MainHeader from './MainHeader';
import Header3 from './Header3';
import WhatIDo from './WhatIDo';
import GallerySlider from './GallerySlider';
import IndustryLeaders from './IndustryLeaders';
import HeroHeader2 from './HeroHeader2';
import HomeText from './HomeText';
import StepProcess from './StepProcess';
import VideoScreen from './VideoScreen';
import BragBar from './BragBar';
import ClientLogos from './ClientLogos';
import AboutText from './AboutText';
import HowWeWork from './HowWeWork';
import CircleHero from './CircleHero';
import BeforeAfter from './BeforeAfter';
import KennstDuDas from './KennstDuDas';
import ClientSelection from './ClientSelection';
import DuWirstLernen from './DuWirstLernen';
import WoraufWartestDu from './WoraufWartestDu';
import FAQ from './FAQ';
import PageFooter from './PageFooter';
import WhatsappPopup from './WhatsappPopup';
import MyStory from './MyStory';
import ScaleUpCall from './ScaleUpCall';
import MorphBackground from './MorphBackground';
import { WHATSAPP_LINKS } from '../config/whatsapp-config';
import { initScrollAnimations, resetScrollAnimations } from '../utils/scrollAnimations';
import './MobileNav.css';

function Home() {
  const [showWhatsappPopup, setShowWhatsappPopup] = useState(false);
  const cleanupAnimations = useRef(null);

  useEffect(() => {
    // Reset scroll position when component mounts (coming from other routes)
    window.scrollTo(0, 0);
    
    // Initialize scroll animations with a slight delay to ensure all components are rendered
    const timer = setTimeout(() => {
      cleanupAnimations.current = initScrollAnimations();
    }, 150);
    
    return () => {
      clearTimeout(timer);
      // Clean up animations when component unmounts
      if (cleanupAnimations.current) {
        cleanupAnimations.current();
      }
    };
  }, []);

  const openBookingCall = useCallback((e) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    setShowWhatsappPopup(true);
  }, []);

  return (
    <>

      <MainHeader />


      <main className="main-content">
        <Header3 />
        <BragBar />
        <div className="gallery-slider-section">
          <GallerySlider />
        </div>
        <VideoScreen />
        <IndustryLeaders />
        <div className="about-text-section">
          <AboutText />
        </div>
        <ScaleUpCall />
        <ClientLogos />
      </main>
      
      <PageFooter />

      <WhatsappPopup 
        isOpen={showWhatsappPopup} 
        onClose={() => setShowWhatsappPopup(false)}
        riderLink={WHATSAPP_LINKS.rider.url}
        trainerLink={WHATSAPP_LINKS.trainer.url}
      />
    </>
  );
}

export default Home; 